const diasDesde = (fecha) =>{
  if (!fecha) return null;
  return Math.floor((Date.now() - new Date(fecha).getTime()) / (1000 * 60 * 60 * 24));
}

const nombreRecepcionista = (r) =>
  r.trabajadores?.find((t) => t.tipo?.toLowerCase() === 'tecnico')?.nombre ?? '—';

const nombresMecanicos = (r) => {
  const mecanicos = r.trabajadores?.filter((t) => t.tipo?.toLowerCase() === 'mecanico') ?? [];
  return mecanicos.length ? mecanicos.map((m) => m.nombre).join(', ') : '—';
};

const nombresServicios = (r) =>
  r.servicios?.length ? r.servicios.map((s) => s.nombre).join(', ') : '—';

const textoRecepcion = (r) => (r.estado_recepcion === 'entregado' ? 'Entregado' : 'Ingresado');
const textoTaller = (r) => (r.estado_taller === 'completo' ? 'Completo' : 'Pendiente');
const textoFirmas = (r) => (r.estado_firmas === 'completo' ? 'Completo' : 'Pendiente');

const diasPendienteTexto = (r) => {
  if (r.estado_recepcion === 'entregado') return 'Entregado';
  const dias = diasDesde(r.fecha_ingreso);
  if (dias === null) return '—';
  return dias === 0 ? 'Hoy' : `${dias} día${dias === 1 ? '' : 's'}`;
};

// pdf:false = solo aparece en Excel (nunca en el PDF, por espacio)
// combinarEnPdf = si va combinada con otra columna solo en el PDF (para ahorrar espacio)
const DEFINICIONES = [
  { header: 'Ingreso', key: 'fecha_ingreso', valor: (r) => (r.fecha_ingreso ? new Date(r.fecha_ingreso).toLocaleDateString('es-CL') : '—'), widthPdf: 55 },
  { header: 'Centro Costo', key: 'nombre_centrocosto', valor: (r) => r.nombre_centrocosto ?? '—', widthPdf: 75 },
  { header: 'Recepciona', key: 'recepciona', valor: nombreRecepcionista, widthPdf: 70 },
  { header: 'Patente', key: 'patente', valor: (r) => r.patente ?? '—', pdf: false },
  {
    header: 'Vehículo', key: 'vehiculo',
    valor: (r) => `${r.marca ?? ''} ${r.modelo ?? ''}`.trim() || '—',
    valorPdf: (r) => `${r.patente ?? '—'}\n${r.marca ?? ''} ${r.modelo ?? ''}`.trim(),
    widthPdf: 75,
  },
  {
    header: 'Cliente', key: 'nombre_cliente',
    valor: (r) => r.nombre_cliente ?? '—',
    valorPdf: (r) => `${r.nombre_cliente ?? '—'}${r.celular_cliente ? `\n+56 ${r.celular_cliente}` : ''}`,
    widthPdf: 95,
  },
  { header: 'Mecánicos', key: 'mecanicos', valor: nombresMecanicos, widthPdf: 100 },
  { header: 'Servicios', key: 'servicios', valor: nombresServicios, pdf: false },
  {
    header: 'Recepción', key: 'estado_recepcion', valor: textoRecepcion, widthPdf: 60,
    estiloPdf: (r) => ({ color: r.estado_recepcion === 'entregado' ? '#1a7a3c' : '#333', bold: r.estado_recepcion === 'entregado' }),
  },
  {
    header: 'Taller', key: 'estado_taller', valor: textoTaller, widthPdf: 55,
    estiloPdf: (r) => ({ color: r.estado_taller === 'completo' ? '#1a7a3c' : '#b3261e' }),
  },
  {
    header: 'Firmas', key: 'estado_firmas', valor: textoFirmas, widthPdf: 55,
    estiloPdf: (r) => ({ color: r.estado_firmas === 'completo' ? '#1a7a3c' : '#b3261e' }),
  },
  { header: 'Días pendiente', key: 'dias_pendiente', valor: diasPendienteTexto, widthPdf: 82 },
];

// ---------------- PDF: solo las columnas marcadas, con ancho fijo pensado para landscape ----------------
export const columnasPDF = DEFINICIONES
  .filter((def) => def.pdf !== false)
  .map((def) => ({
    header: def.header,
    width: def.widthPdf ?? 'auto',
    get: (r) => ({
      text: (def.valorPdf ?? def.valor)(r),
      margin: [0, 6, 4, 4],
      ...(def.estiloPdf ? def.estiloPdf(r) : {}),
    }),
  }));

// ---------------- Excel: todas las columnas, sin restricción de ancho de página ----------------
export const columnasExcel = DEFINICIONES.map((def) => ({
  header: def.header,
  key: def.key,
  get: def.valor,
}));